var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemarks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36563 15.0281L5.18437 15.8625C4.95625 16.025 4.65625 16.0437 4.40625 15.9156C4.15625 15.7875 4 15.5312 4 15.25V13H3C1.34375 13 0 11.6562 0 10V3C0 1.34375 1.34375 0 3 0H13C14.6562 0 16 1.34375 16 3V10C16 11.6562 14.6562 13 13 13H9.2375L6.36563 15.0281ZM8.375 11.775C8.62813 11.5969 8.93125 11.5 9.24063 11.5H13C13.8281 11.5 14.5 10.8281 14.5 10V3C14.5 2.17188 13.8281 1.5 13 1.5H3C2.17188 1.5 1.5 2.17188 1.5 3V10C1.5 10.8281 2.17188 11.5 3 11.5H4.75C5.075 11.5 5.35313 11.7063 5.45625 11.9969C5.48438 12.075 5.5 12.1594 5.5 12.25V13.8031C6.52187 13.0813 7.47812 12.4062 8.37187 11.775H8.375Z",
    fill: "#1754AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemarks);
export default __webpack_public_path__ + "static/media/remarks.f25dfabd471e8dd1ab72a165f9bfb9e2.svg";
export { ForwardRef as ReactComponent };